import { render, staticRenderFns } from "./singleCourse.vue?vue&type=template&id=735ef5e1&scoped=true&"
import script from "./singleCourse.vue?vue&type=script&lang=js&"
export * from "./singleCourse.vue?vue&type=script&lang=js&"
import style0 from "./singleCourse.vue?vue&type=style&index=0&id=735ef5e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735ef5e1",
  null
  
)

export default component.exports